import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import axios from 'axios';
import swal from "sweetalert2";

const BtnConvertDocDeliveryNoteB2b = (props) => {
    const t = useTranslate();
    const [loading,setLoading] = useState(false)

    const handleClick = async () => {
        setLoading(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/facture/dossier_b2b/convert_all_delivery_note/"+props.dossierId
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
                setLoading(false)
            }
            else{   
                props.setReload(Date.now())
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
        setLoading(false)
    }

    return(
        <button disabled={props.disabled || loading} className={props.btnStyle} 
            onClick={()=>swal.fire({
                title: t('convertFolderDeliveryNoteSwal'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: t('btnYes'),
                cancelButtonText: t('btnNo'),
                allowOutsideClick: false,
            })
            .then((result) => {
                if (result.value) {
                    handleClick()
                }
            })}
        >
            {t('convertFolderDeliveryNote')}
        </button>
    )
}

export default BtnConvertDocDeliveryNoteB2b;